module.exports = __webpack_public_path__ + "static/img/join_12.853c7a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join_12.jpg
// module id = kpZT
// module chunks = 1